import { checkFeatureAccess } from "../../../services/commonServices"
import { ChatModes } from "../types";

export const checkChatPermission = async (chatType: ChatModes): Promise<boolean> => {
    try {
        return await checkFeatureAccess(chatType);
    } catch (error: any) {
        console.error("Failed to check chat permission:", error);
        throw error;
    }
}